import { gql } from '@apollo/client';

export const DOMAIN_RATES_QUERY = gql`
  query DomainRates($id: Int!) {
    domainById(id: $id) {
      id
      name
      draperyCutLaborCost
      rateDrapeInstallPerFt
      rateDrapeInstallMin
      rateHospitalTrackPerFt
      liningRegularCost
      liningBlackoutCost
      liningSheerCost
      interliningBumpCost
      interliningFlannelCost
      draperyTrimLaborCostPerYard
      draperyCtmHardwareCost
      romanShadeLaborCostPerSqFt
      romanShadeInstallPerWidth
      romanShadeInstallMin
      romanShadeBoardSmallCost
      romanShadeBoardLargeCost
      romanShadeVelcroCostPerYard
      romanShadeTrimLaborCostPerYard
      romanShadeCordCleatCost
      romanShadeRolleaseCost
      rateValanceInstallPerFt
      rateValanceInstallMin
      ratePleatedFabPerCut
      shirredValanceFabPerCut
      shirredValanceInstallPerFt
      shirredValanceInstallMin
      shirredValanceBoardSmallCost
      shirredValanceBoardLargeCost
      shirredValanceVelcroCostPerYard
      shirredValanceTrimLaborCostPerYard
      rateBalloonFabPerSqft
      rateAustrianFabPerSqft
      rollerShadeFabricationNarrowCost
      rollerShadeFabricationWideCost
      rollerShadeInstallationCost
      rollerShadeInstallationMinCost
      rollerShadeSmallRodPerFootCost
      rollerShadeMediumRodPerFootCost
      rollerShadeHeavyRodPerFootCost
      rollerShadeSmallClutchAndIdleEndSetCost
      rollerShadeMediumClutchAndIdleEndSetCost
      rollerShadeLargeClutchAndIdleEndSetCost
      rollerShadeExtraClutchAndIdleEndSetCost
      rollerShadeWandMotorCost
      rollerShadeBottomBarStandardPerFootCost
      rollerShadeBottomBarBlackoutPerFootCost
      rollerShadeFasciaPerFoot3InCost
      rollerShadeFasciaPerFoot4InCost
      rollerShadeFasciaBrackets3InCost
      rollerShadeFasciaBrackets4InCost
      rollerShadeEndcapsStandardCost
      rollerShadeEndcapsBlackoutCost
      rollerShadeChainsCoversCost
      rollerShadeTapeCost
      rollerShadeShippingCost
      rollerShadeRetailPriceMarkup
      rollerShadeCustomWoodFasciaCostPerFoot
      rateSomfyMotor30
      rateSomfyMotor40
      rateRolleaseMotor
      remotePriceOneShade
      remotePriceTwoToFourShades
      remotePriceGreaterThanFourShades
      rateTrimLaborPerYd
      rateVelcroPerYd
      rateDelivery
      ratePillowZipper
      rateBolsterZipper
      rateCushionZipperShort
      rateCushionZipperLong
      rateCushionLaborThin
      rateCushionLaborThick
      rateCushionInsertDacron
      rateCushionInsertDownWrap
      rateCushionInsertDown
      rateDuvetZipper
      rateMeasureCharge
      benchUtfStandardCostPerInch
      benchUtfUpgradeCostPerInch
      benchStorageOptionCost
      benchLegsStandardCostPerInch
      benchLegsUpgradeCostPerInch
      benchTrimLaborCostPerYard
      benchNailheadLaborCostPerFoot
      benchDeliveryCost
      corniceLaborCostPerFootStandard
      corniceLaborCostPerFootTall
      corniceShapedBottomCostPerFoot
      corniceTrimLaborCostPerYard
      corniceWeltLaborCostPerYard
      corniceNailheadLaborCostPerFoot
      corniceInstallCostPerFoot
      bedHeadboardLaborRateLow
      bedHeadboardLaborRateHigh
      bedHeadboardShapedExtraPerInch
      bedTuftedChanneledLaborUpchargePct
      bedTrimCostPerYard
      bedSideRailCostPerFoot
      bedFootboardCostPerFoot
      bedFootboardOverageCostPerFoot
      bedDrawerSmallCost
      bedDrawerLargeCost
      bedTrundleCost
      bedWoodFeetCostSmall
      bedWoodFeetCostLarge
      bedBunkyBoardCostSmall
      bedBunkyBoardCostMedium
      bedBunkyBoardCostLarge
      bedDeliveryInstallationCost
      pinBoardCostPerSqFt
      pinBoardFrameCostPerInch
      pinBoardRibbonNailheadCostPerYard
      pinBoardVelcroCostPerYard
      pinBoardFrenchCleatCost
      pinBoardDeliveryInstallationCost
      pinBoardMeasureTemplateCost
    }
  }
`;

export const UPDATE_DOMAIN_RATES_MUTATION = gql`
  mutation UpdateDomainRates($id: Int!, $patch: DomainPatch!) {
    updateDomainById(input: { id: $id, domainPatch: $patch }) {
      domain {
        id
      }
    }
  }
`;
